
const notification = {
    list: () => 'getAllPushNotification',
    city: () => `get/all/cities/byStateNames`,
    subAddLines: () => `get/all/subAddLines`,
    zipcode: () => `get/all/zipCodes`,
    state: (countryID) => `getStatesByCountryId`,
    country: () => 'allcountries?admin=true',
    delete: (id) => `delete/pushNotification/${id}`,
    send: (id) => `sendPushNotification/${id}`,
    test: (id) => `sendTestNotification`,
}
export default notification
